export const INTERVIEW_ACTION = Object.freeze({
  IDLE: 'idle' as const,
  APPROVE: 'approve' as const,
  REJECT: 'reject' as const,
});

export type InterviewAction = (typeof INTERVIEW_ACTION)[keyof typeof INTERVIEW_ACTION];
